import { Component, OnInit, Output,Input, EventEmitter  } from '@angular/core';
import { LeftBarType } from '../../comm/class/leftbarjson';
import { Dep } from '../../comm/class/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-otmain-sidebarmoblie',
  templateUrl: './otmain-sidebarmoblie.component.html',
  styleUrls: ['./otmain-sidebarmoblie.component.css']
})
export class OtmainSidebarmoblieComponent implements OnInit {

  	//0 arr  1 文字  2radio
	  loading:boolean=true;
	  now:number = -1;
	  power:number;
	  list : LeftBarType = [];
	  isDesktop: boolean; 
   
	  @Input() user: any;
	  @Output() notify = new EventEmitter<any>();
	  constructor(private route: ActivatedRoute,public httpClient: HttpClient,) { }

  menu_hit(id: number) {
    if (!id || id >= 9990) { return; } // 9997/9998 為前端注入的假選單，無對應 admin_menu 列
    this.httpClient.post<any>("/customer_service/menu_hit.php", { id }).subscribe(() => {}, () => {}); // fire-and-forget，錯了也不擋導航
  }

   
	  menu_open(item){
		  this.list.map((obj, index) => {
			  if( obj.id==item.id){
				  obj.active = true;
			  }else{
				  obj.active = false;
			  }
		 
			  return obj;
		  });
	  }
   
   
	  ngOnInit(): void {
		  this.init_list();  
		  this.power = Dep.auth.power_id;
		  this.checkDeviceType();
		  window.addEventListener('resize', () => {
			  this.checkDeviceType();
		  });
	  }
   
	  init_list(){
		  this.loading = true;
		  const body = {};
		  this.httpClient.post<any>("/customer_service/get_menu_list.php",body).subscribe(res => {
			  this.loading = false;
			  this.list = res.data;
			  let urlname = location.pathname;
			  for(let i in this.list){
				  let item = this.list[i].subitem;
				  for(let a in item){
					  if(urlname.indexOf(item[a].url)!=-1){
						  this.list[i].active = true;
						  this.now = item[a].id;
					  }
				  }
			  }
		  }, error => {
			  console.log(error);
		  });
	  }
   
	  checkDeviceType() {
		  if (window.innerWidth > 768) { // 假設768px是切換點
			  this.isDesktop = true;
		  } else {
			  this.isDesktop = false;
		  }
	  }
}
